import React, { useEffect, useRef, useState } from 'react'
import { config } from '../../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios'
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import allowNumbersOnly, { handlePaste } from '../../../CommonUtils/CommonValidations'
import Swal from 'sweetalert2'
import * as Yup from 'yup';
import moment from 'moment';
import { useDispatch } from 'react-redux'
import { AC_YEAR_OLD, ERROR_MSG } from '../../../CommonUtils/contextVariables'
import { failureAlert, successAlert2 } from '../../../CommonUtils/SweetAlerts'
function RenewalofExistingCourses() {
    const acYear = sessionStorage.getItem('ac_year');

    const [getData, setData] = useState([])
    const hasFetchedData = useRef(false)
    const dispatch = useDispatch();
    const validationSchema1 = Yup.object().shape({
        data: Yup.array().of(
            Yup.object().shape({
                approvNoOfSections: Yup.string().required(ERROR_MSG).nullable(),
                accredition: Yup.string().required(ERROR_MSG).nullable(),
                exstCourseCompetentAuthAppr21: Yup.string().required(ERROR_MSG).nullable(),

                exstCourseEoaEop21: Yup.string().when('exstCourseCompetentAuthAppr21', {
                    is: 'true',
                    then: Yup.string().required(ERROR_MSG).nullable(),
                    otherwise: Yup.string().notRequired(),
                }),
                exstCourseCompetentAuthIntake21: Yup.string().when('exstCourseEoaEop21', {
                    is: 'true',
                    then: Yup.string().required(ERROR_MSG).nullable(),
                    otherwise: Yup.string().notRequired(),
                }),

                exstCourseRequestedIntake21: Yup.string().when('exstCourseEoaEop21', {
                    is: 'true',
                    then: Yup.string().required(ERROR_MSG),
                    otherwise: Yup.string().notRequired(),
                }),
            })
        )
    });
    const RenewCoursesformik = useFormik({
        initialValues: {
            data: [{
                slno: '',
                acYear: '',
                collCode: '',
                exstCourseCompetentAuthAppr21: '',
                exstCourseEoaEop21: '',
                exstCourseCompetentAuthIntake21: '',
                exstCourseRequestedIntake21: '',
                accredition: '',
                accreditionValidUpto: '',
                approvNoOfSections: '',

            }]
        },
        // validationSchema: validationSchema1,
        enableReinitialize: true,
        // onSubmit: (val) => {
        //     console.log("va", val?.data)
        //     Swal.fire({
        //         text: 'Are you sure you want to submit?',
        //         icon: 'warning',
        //         showCancelButton: true,
        //         confirmButtonText: 'Yes, submit it!',
        //         cancelButtonText: 'No, cancel!',
        //         backdrop: false,
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             let url = config.url.API_URL + `saveExistingCourses`
        //             CommonAxiosPost(url, val.data).then((res) => {
        //                 if (res?.data?.scode === '01') {
        //                     Swal.fire(res?.data?.sdesc, '', 'success').then((res) => {
        //                         if (res?.isConfirmed) {
        //                             GetData()
        //                         }
        //                     })
        //                 }
        //                 else {
        //                     failureAlert("Failed to submit")

        //                 }
        //             })
        //         }
        //     })

        // }
        onSubmit: (val) => {
            const invalidItems = [];
            val?.data?.forEach((item, index) => {
                const rowNum = `Row ${index + 1}`;

                // Check if Competent Authority Approval is required
                if (!item.exstCourseCompetentAuthAppr21 || item.exstCourseCompetentAuthAppr21 === "") {
                    invalidItems.push(`${rowNum}: Competent Authority Approval is required.`);
                }

                // If Competent Authority Approval is true
                if (item.exstCourseCompetentAuthAppr21 === "true") {

                    // Then EOA/EOP should be present
                    if (!item.exstCourseEoaEop21 || item.exstCourseEoaEop21 === "") {
                        invalidItems.push(`${rowNum}: EOA/EOP is required `);
                    }

                    // If EOA/EOP is also true
                    if (item.exstCourseEoaEop21 == "true") {

                        if (!item.exstCourseCompetentAuthIntake21 || item.exstCourseCompetentAuthIntake21 === "") {
                            invalidItems.push(`${rowNum}: Competent Authority Intake is required.`);
                        }
                        if (item.exstCourseRequestedIntake21 === "" || item.exstCourseRequestedIntake21 === undefined || item.exstCourseRequestedIntake21 === null) {
                            invalidItems.push(`${rowNum}: Requested Intake is required.`);
                        }
                    }
                }
                console.log("Item object:", JSON.stringify(item, null, 2));
                // Always validate base required fields
                if (!item.approvNoOfSections || item.approvNoOfSections === "") {
                    invalidItems.push(`${rowNum}: Number of Sections is required.`);
                }

                if (!item.accredition || item.accredition === "") {
                    invalidItems.push(`${rowNum}: Accreditation is required.`);
                }

            });

            if (invalidItems.length > 0) {
                Swal.fire({
                    title: 'Required Fields',
                    icon: 'error',
                    html: invalidItems.join('<br>'),
                    confirmButtonText: 'Ok',
                    backdrop: false
                });
                return; // Stop submission
            }

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',

            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `saveExistingCourses`;
                    CommonAxiosPost(url, val.data).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc).then((res) => {
                                if (res?.isConfirmed) {
                                    GetData();
                                }
                            });
                        } else {
                            failureAlert("Failed to submit");
                        }
                    });
                }
            });
        }


    })

    function GetData() {
        let url = config.url.API_URL + `getExistingCourses`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                let data = res?.data?.getExistingCourses
                setData(data)
                let update = data?.length > 0 ? data?.map((ec) => ({
                    slno: ec?.slno || '',
                    exstCourseCompetentAuthAppr21: ec?.exst_course_competent_auth_appr_21 === true && 'true' || ec?.exst_course_competent_auth_appr_21 === false && 'false' || '',
                    exstCourseEoaEop21: ec?.exst_course_eoa_eop_21 === true && 'true' || ec?.exst_course_eoa_eop_21 === false && 'false' || '',
                    exstCourseCompetentAuthIntake21: ec?.exst_course_competent_auth_intake_21 || '',
                    exstCourseRequestedIntake21: ec?.exst_course_requested_intake_21 || '',
                    accredition: ec?.accredition || '',
                    accreditionValidUpto: moment(ec?.affl_valid_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') || '',
                    approvNoOfSections: ec?.approv_no_of_sections || '',

                })) : [{
                    slno: '',
                    exstCourseCompetentAuthAppr21: '',
                    exstCourseEoaEop21: '',
                    exstCourseCompetentAuthIntake21: '',
                    exstCourseRequestedIntake21: '',
                    accredition: '',
                    accreditionValidUpto: '',
                    approvNoOfSections: ''
                }]
                RenewCoursesformik.setFieldValue('data', update);
                // res?.data?.getExistingCourses?.forEach((data, i) => {
                //     console.log("data>>", data?.approv_no_of_sections)
                //     RenewCoursesformik?.setFieldValue(`data[${i}].approvNoOfSections`, data?.approv_no_of_sections);
                //     RenewCoursesformik?.setFieldValue(`data[${i}].courseWithdrawl`, data?.course_withdrawl);
                //     RenewCoursesformik?.setFieldValue(`data[${i}].courseWithdrawlReason`, data?.course_withdrawl_reason);

                // })

            }
            else {
                setData([])
            }
        })

    }
    function GetStatus() {
        let url = config.url.API_URL + `getcouresFlags`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                dispatch({ type: "Coursesflags", payload: res?.data?.couresFlags[0] });

            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetData()
            GetStatus()
            hasFetchedData.current = true
        }
    }, [])


    useEffect(() => {

        if (getData) {
            const dataitialValues = getData?.map(course => ({
                slno: course?.slno,
                exstCourseCompetentAuthAppr21: course?.exst_course_competent_auth_appr_21 === true ? "true" : course?.exst_course_competent_auth_appr_21 === false ? "false" : '',
                exstCourseEoaEop21: course?.exst_course_eoa_eop_21 === true ? "true" : course?.exst_course_eoa_eop_21 === false ? "false" : '',
                exstCourseCompetentAuthIntake21: course?.exst_course_competent_auth_intake_21,
                // exstCourseRequestedIntake21: course?.exstCourseRequestedIntake21,
                exstCourseRequestedIntake21: course?.exst_course_requested_intake_21,
                accredition: course?.accredition,
                // accreditionValidUpto: course?.affl_valid_upto,
                approvNoOfSections: course?.approv_no_of_sections,
            }));
            RenewCoursesformik.setValues({ ...RenewCoursesformik?.values, data: dataitialValues });
        }
    }, [getData]);
    return (
        <>
            <FormikProvider value={RenewCoursesformik}>
                <Form onChange={RenewCoursesformik.handleChange} onSubmit={RenewCoursesformik.handleSubmit} className='affl-form'>
                    {getData?.length > 0 ? (<>
                        <h5>1. College Application for Renewal of the Affiliation of the Existing courses</h5>

                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                <thead>
                                    <tr>
                                        <th>Sno</th>
                                        <th >Academic Program Type</th>
                                        <th>Course /Program</th>
                                        <th>Branch /Combination</th>
                                        <th>Medium</th>
                                        <th>Afiliation Permanent/Temporary</th>
                                        <th>Intake Approved for {AC_YEAR_OLD}</th>
                                        <th>Approved No. of Sections</th>
                                        <th>Course Duration</th>
                                        <th>Accreditation Conferred (NBA/NAAC)</th>
                                        <th>Affiliation Valid up to</th>
                                        <th >Has competent Authority( AICTE/CHE/BCI/PCI) Approved this course for Academic year {acYear}</th>
                                        <th >Is this course available in the Latest EOP/EOA/ Course Sanction Order issued by the competent Authority ( Yes/No)</th>
                                        <th>If available Please specify the Intake approved by competent Authority</th>
                                        <th>Intake being requested by College for this academic year {acYear}</th>
                                        <th>Campus Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {getData.map((ec, i) => (
                                        <tr >
                                            <td>{i + 1}</td>
                                            <td className='text-left' >{ec?.course_group_desc}</td>
                                            <td className='text-left'>{ec?.course_cat_name}</td>
                                            <td className='text-left'>{ec?.course_name}</td>
                                            <td>{ec?.name}</td>
                                            <td>{ec?.course_affl_type}</td>
                                            <td>{ec?.final_sanction_intake || '-'}</td>
                                            <td><Field type='text' name={`data[${i}].approvNoOfSections`} className='form-control' maxLength='2'
                                                onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} />
                                                <ErrorMessage name={`data[${i}].approvNoOfSections`} className='text-error' component='div' />
                                            </td>
                                            <td>{ec?.duration}</td>
                                            <td><Field as='select' name={`data[${i}].accredition`} className='form-control'>
                                                <option value=''>--SELECT--</option>
                                                <option value="NBA">NBA</option>
                                                <option value="NAAC">NAAC</option>
                                                <option value="None">None</option>
                                            </Field>
                                                <ErrorMessage name={`data[${i}].accredition`} className='text-error' component='div' />
                                            </td>
                                            <td>{ec?.affl_valid_upto ?? "-"}</td>
                                            <td><Field as='select' name={`data[${i}].exstCourseCompetentAuthAppr21`} className='form-control'
                                                onChange={(e) => {
                                                    if (e.target.value == "false") {
                                                        RenewCoursesformik?.setFieldValue(`data[${i}].exstCourseEoaEop21`, '');
                                                        RenewCoursesformik?.setFieldValue(`data[${i}].exstCourseCompetentAuthIntake21`, '');
                                                        RenewCoursesformik?.setFieldValue(`data[${i}].exstCourseRequestedIntake21`, '');
                                                    }
                                                }}>
                                                <option value=''>--SELECT--</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </Field>
                                                <ErrorMessage name={`data[${i}].exstCourseCompetentAuthAppr21`} className='text-error' component='div' />
                                            </td>
                                            <td>
                                                {RenewCoursesformik?.values?.data[i]?.exstCourseCompetentAuthAppr21 == "true" && (
                                                    <>
                                                        <Field as='select' name={`data[${i}].exstCourseEoaEop21`} className='form-control'
                                                            onChange={(e) => {
                                                                if (e.target.value === "false") {
                                                                    RenewCoursesformik?.setFieldValue(`data[${i}].exstCourseCompetentAuthIntake21`, '');
                                                                    RenewCoursesformik?.setFieldValue(`data[${i}].exstCourseRequestedIntake21`, '');
                                                                }
                                                            }}>
                                                            <option value=''>--SELECT--</option>
                                                            <option value="true">Yes</option>
                                                            <option value="false">No</option>
                                                        </Field>
                                                        <ErrorMessage name={`data[${i}].exstCourseEoaEop21`} className='text-error' component='div' />
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                {RenewCoursesformik?.values?.data[i]?.exstCourseEoaEop21 == "true" && (
                                                    <>
                                                        <Field type='text' name={`data[${i}].exstCourseCompetentAuthIntake21`} className='form-control' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} maxLength="5" />
                                                        <ErrorMessage name={`data[${i}].exstCourseCompetentAuthIntake21`} className='text-error' component='div' />
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                {RenewCoursesformik?.values?.data[i]?.exstCourseEoaEop21 == "true" && (
                                                    <>
                                                        <Field type='text' name={`data[${i}].exstCourseRequestedIntake21`} className='form-control' onKeyPress={(e) => allowNumbersOnly(e)} onPaste={(e) => handlePaste(e)} maxLength="5" />
                                                        <ErrorMessage name={`data[${i}].exstCourseRequestedIntake21`} className='text-error' component='div' />
                                                    </>
                                                )}
                                            </td>
                                            <td style={{ width: "800px" }}>
                                                {ec?.campus_type === "off" ? "Off Campus" : ec?.campus_type === "main" ? "Main Campus" : "-"}

                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <button type='submit' className='btn btn-success btn-sm float-end mt-3'>Submit</button><pre /><pre /><pre />

                    </>) : (<center className='text-danger h5 pt-5'>***** No Data Found *****</center>)}
                </Form>
            </FormikProvider>
        </>
    )
}

export default RenewalofExistingCourses